import firebase from "js/firebase";
import { openWindowAndWaitForItToBeClosed } from "js/core/utilities/selfClosingWindow";

export class BoxAuthError extends Error { }
export class BoxAuthFlowWasInterruptedError extends BoxAuthError { }

interface BoxAuthTokens {
    accessToken: string
}

/**
 * Grants our app offline access for the given scope, executes the redirect ouath flow in a separate window
 * and saves the tokens
 */
export async function grantOfflineAccess(): Promise<BoxAuthTokens> {
    const userIdToken = await firebase.auth().currentUser.getIdToken();

    const url = `${window.location.origin}/box/auth` +
        `?continueUrl=${encodeURIComponent("/close")}` +
        `&userIdToken=${encodeURIComponent(userIdToken)}` +
        "&requestOfflineAccess=true";

    const lastSearchParams = await openWindowAndWaitForItToBeClosed(url);

    const accessToken = lastSearchParams.get("box_access_token");
    const error = lastSearchParams.get("box_auth_error");

    if (error) {
        throw new BoxAuthError(error);
    }

    if (!accessToken && !error) {
        throw new BoxAuthFlowWasInterruptedError();
    }

    return { accessToken };
}
